var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileInformationDarkblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15243_43929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68024 20.4017C5.44523 19.146 6.52038 18.1082 7.80232 17.3882C9.08426 16.668 10.5299 16.2898 12.0002 16.2898C13.4706 16.2898 14.9162 16.668 16.1982 17.3882C17.4802 18.1082 18.5552 19.146 19.3203 20.4017M12.0003 13.716C14.3672 13.716 16.286 11.7972 16.286 9.43032C16.286 7.06338 14.3672 5.1446 12.0003 5.1446C9.63335 5.1446 7.71456 7.06338 7.71456 9.43032C7.71456 11.7972 9.63335 13.716 12.0003 13.716ZM12.0003 23.1446C18.1544 23.1446 23.1431 18.1559 23.1431 12.0017C23.1431 5.84772 18.1544 0.858887 12.0003 0.858887C5.84625 0.858887 0.857422 5.84772 0.857422 12.0017C0.857422 18.1559 5.84625 23.1446 12.0003 23.1446Z",
    stroke: "#252938",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15243_43929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInformationDarkblue);
export default __webpack_public_path__ + "static/media/Profile-information-darkblue.ecbd9f74.svg";
export { ForwardRef as ReactComponent };